export function scrollToTargetAdjusted(target) {
	if (target) {
		const headerOffset = 72;
		const targetPosition = target.getBoundingClientRect().top;
		const offsetPosition = targetPosition + window.pageYOffset - headerOffset;
		window.scrollTo({ top: offsetPosition, behavior: "smooth" });
	}
}